import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import {
	IDishAssignmentContext,
	DishAssignmentContext,
} from '../../../../../dishAssignmentState/dishAssignmentContext';
import Button from 'components/Button/Button';
import { DownOutlined } from '@ant-design/icons';
import style from './AssignBtn.module.scss';

const AssignBtn: React.FC = () => {
	const { addSelectedDishesToSubcategory, IDsSelectedDishes, IDsSelectedSubcategories } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);

	const isOpenSubcategoryTabs = useMemo(() => {
		const countOfOpenTabs = Object.keys(IDsSelectedSubcategories).filter(
			(id) => IDsSelectedSubcategories[id] === true,
		).length;
		return countOfOpenTabs > 0;
	}, [IDsSelectedSubcategories]);

	return (
		<Button
			className={style.assignBtn}
			theme="primary"
			onClick={addSelectedDishesToSubcategory}
			disabled={IDsSelectedDishes.length < 1 || !isOpenSubcategoryTabs}
			data-test="AssignBtn"
			iconPosition="post"
			icon={<DownOutlined className={style.icon} rotate={270} />}>
			<Text translationNameSpace="listing" translationKey="assignButton" asFragment={true} />
		</Button>
	);
};

export default AssignBtn;
